// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currency-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
}
.currency-badge-logo {
  display: flex;
}
.currency-badge-logo > img {
  width: 24px;
}
.currency-badge-text {
  font-family: Jost, "sans-serif";
  font-weight: 500;
  font-size: 16px;
}
.currency-badge-icon {
  display: flex;
}
.currency-badge-icon > img {
  height: 15px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
